import React from 'react';

const TermsOfService = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1 className="page-title">Terms of Service</h1>
        <p className="policy-date">Last updated: 1 January 2026</p>

        <section className="policy-section">
          <h2>1. Introduction</h2>
          <p>These Terms of Service ("Terms") govern your use of the World Financial Award website and services operated by World Financial Award Ltd, a company registered in England and Wales ("we", "us", "our"). By accessing or using our website, you agree to be bound by these Terms in accordance with the laws of England and Wales.</p>
        </section>

        <section className="policy-section">
          <h2>2. Use of the Website</h2>
          <p>You may use our website for lawful purposes only. You must not:</p>
          <ul>
            <li>Use our website in any way that breaches any applicable local, national, or international law or regulation.</li>
            <li>Use our website to transmit or procure the sending of any unsolicited or unauthorised advertising or promotional material.</li>
            <li>Attempt to gain unauthorised access to any part of our website, the server on which our website is stored, or any server, computer, or database connected to our website.</li>
            <li>Use our website to knowingly transmit any data or material that contains viruses, trojan horses, or any other harmful programs.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Award Nominations and Entries</h2>
          <p>By submitting a nomination or competition entry:</p>
          <ul>
            <li>You warrant that all information provided is accurate, complete, and not misleading.</li>
            <li>You acknowledge that the selection of winners is at the sole discretion of our judging panel and that their decision is final.</li>
            <li>You consent to the publication of your company name, logo, and award category in connection with the World Financial Award programme.</li>
            <li>Entry fees, where applicable, are non-refundable once payment has been processed.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Intellectual Property</h2>
          <p>All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of World Financial Award Ltd or its licensors and is protected by United Kingdom and international copyright, trademark, and other intellectual property laws.</p>
          <p>The "World Financial Award" name, logo, and associated branding are registered trademarks. You may not reproduce, distribute, or use any content from this website without our prior written consent.</p>
        </section>

        <section className="policy-section">
          <h2>5. Limitation of Liability</h2>
          <p>To the fullest extent permitted by English law:</p>
          <ul>
            <li>We exclude all implied conditions, warranties, representations, or other terms that may apply to our website or any content on it.</li>
            <li>We shall not be liable for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, arising out of or in connection with the use of our website.</li>
            <li>Nothing in these Terms excludes or limits our liability for death or personal injury arising from our negligence, fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or limited by English law.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Third-Party Links</h2>
          <p>Our website may contain links to third-party websites. We have no control over the content of those sites and accept no responsibility for them or for any loss or damage that may arise from your use of them.</p>
        </section>

        <section className="policy-section">
          <h2>7. Indemnification</h2>
          <p>You agree to indemnify and hold harmless World Financial Award Ltd, its directors, officers, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising from your use of the website or any breach of these Terms.</p>
        </section>

        <section className="policy-section">
          <h2>8. Amendments</h2>
          <p>We may revise these Terms at any time by amending this page. You are expected to check this page from time to time to take notice of any changes we make, as they are binding on you.</p>
        </section>

        <section className="policy-section">
          <h2>9. Governing Law and Jurisdiction</h2>
          <p>These Terms shall be governed by and construed in accordance with the laws of England and Wales. Any disputes arising under or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
        </section>

        <section className="policy-section">
          <h2>10. Contact</h2>
          <p>For any questions regarding these Terms, please contact:<br />
          World Financial Award Ltd<br />
          Email: <a href="mailto:info@worldfinancialaward.com">info@worldfinancialaward.com</a><br />
          London, United Kingdom</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
